import { Caract_anteproyecto_obranueva } from '../../../models/caract_anteproyecto_obranueva.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';
import * as moment from 'moment'

@Component({
    selector: "page-Caract_anteproyecto_obranueva",
    templateUrl: "./Caract_anteproyecto_obranueva.component.html",
    styleUrls: ["./Caract_anteproyecto_obranueva.component.css"],
    providers: [FormService]
})

export class Caract_anteproyecto_obranuevaComponent {
    public rows = [];
    public actualRow;
    public caract_anteproyecto_obranueva: Caract_anteproyecto_obranueva;
    public form;
    public matcher = new FormService();
    public formNumber;
    public formulario;
    public proyectoAnte = "";
    public tituloContinuacion = "";


    public form111;
    public form112;
    public form113;
    public form114;
    public form115;

    public form131 = false;
    public form132 = false;
    public form133 = false;
    public form152 = false;
    public form153 = false;
    public form154 = false;

    public form211;
    public form212;
    public form213;
    public form214;

    public form231;
    public form232;
    public form233;
    public form234;
    public form235;

    public form251;
    public form252;
    public form253;
    public form254;
    public form255;

    public form273;

    public fecha;
    public maxDate;
    public tipo_alt;
    public tipo_rec;
    public alteracionSupresionAdicion = false;
    public alteracionResRemReh = false;
    public typeEdificioPublic = ''
    public num

    alteracion = ["Supresión o adición", "Restauración", "Remodelación", "Rehabilitación", "Fachada", "Estructura", "Monumento Nacional", "Inmueble en zona de conservación histórica", "Inmueble de conservación histórica"]
    constructor() {

        this.formulario = localStorage.getItem("form")


        if (this.formulario == "1-1.1") {
            this.form111 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " de ampliación calificado como obra menor"
            this.typeEdificioPublic = '(original + ampliación) '
            this.num = '6'
        }
        if (this.formulario == "1-1.2") {
            this.form112 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " de obra menor"
            this.typeEdificioPublic = 'original con modificación'
            this.num = '6'
        }
        if (this.formulario == "1-1.3") {
            this.form113 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " de ampliación de vivienda social y otras"
            this.num = '6'
        }
        if (this.formulario == "1-1.4") {
            this.form114 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " de la edificación que se regulariza"
            this.typeEdificioPublic = '(todo - o original más ampliación)'
            this.num = '6'
        }
        if (this.formulario == "1-1.5") {
            this.form115 = true;
        }
        if (this.formulario == "1-3.1") {
            this.form131 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " de ampliación calificado como obra menor modificado"
            this.typeEdificioPublic = '(incluida la modificación)'
            this.num = '6'
        }
        if (this.formulario == "1-3.2") {
            this.form132 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " de ampliación de vivienda social y otras modificaciones"
            this.num = '6'
        }
        if (this.formulario == "1-3.3") {
            this.form133 = true;
            this.num = '6'
        }
        if (this.formulario == "1-5.2") {
            this.form152 = true;
            this.num = '6'
        }
        if (this.formulario == "1-5.4") {
            this.form154 = true;
            this.num = '6'
        }

        if (this.formulario == "2-1.1") {
            this.form211 = true;
            this.proyectoAnte = " del anteproyecto"
            this.tituloContinuacion = " obra nueva"
            this.num = '5'
        }
        if (this.formulario == "2-1.2") {
            this.form212 = true;
            this.proyectoAnte = " del anteproyecto"
            this.tituloContinuacion = " ampliación mayor a 100 m2"
        }
        if (this.formulario == "2-1.3") {
            this.form213 = true;
            this.proyectoAnte = " del anteproyecto"
            this.tituloContinuacion = " alteración"
        }
        if (this.formulario == "2-1.4") {
            this.form214 = true;
            this.proyectoAnte = " del anteproyecto"
            this.tituloContinuacion = " reconstrucción"
        }

        if (this.formulario == "2-3.1") {
            this.form231 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " obra nueva"
        }
        if (this.formulario == "2-3.2") {
            this.form232 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " ampliación mayor a 100 m2"
        }
        if (this.formulario == "2-3.3") {
            this.form233 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " alteración"
        }
        if (this.formulario == "2-3.4") {
            this.form234 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " reconstrucción"
        }
        if (this.formulario == "2-3.5") {
            this.form235 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " reparación"
        }

        if (this.formulario == "2-5.1") {
            this.form251 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " obra nueva modificado"
        }
        if (this.formulario == "2-5.2") {
            this.form252 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " ampliación mayor a 100 m2 modificado"
        }
        if (this.formulario == "2-5.3") {
            this.form253 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " alteración modificado"
        }
        if (this.formulario == "2-5.4") {
            this.form254 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " reconstrucción modificado"
        }
        if (this.formulario == "2-5.5") {
            this.form255 = true;
            this.proyectoAnte = " del proyecto"
            this.tituloContinuacion = " reparación modificado"
        }
        if (this.formulario == "2-7.3") {
            this.form273 = true;
        }

        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            anteProyectoAprobado: new FormControl(''),
            anteProyectoAprobadoRes: new FormControl(''),
            anteProyectoAprobadoFecha: new FormControl(''),
            tipo_permiso: new FormControl(''),
            num_permiso: new FormControl(''),
            fecha_permiso: new FormControl(''),
            tipo_recepcion: new FormControl(''),
            num_recepcion: new FormControl(''),
            fecha_recepcion: new FormControl(''),
            edificio_usoPublico: new FormControl(''),
            carga_ocupacionTotal: new FormControl('0'),
            carga_ocupacionTotalReconstruccion: new FormControl(''),
            densidadOcupacion: new FormControl('0'),
            densidadOcupacionReconstruccion: new FormControl(''),
            crecimientoUrbano: new FormControl(''),
            explicitar: new FormControl(''),
            loteo_construccion: new FormControl(''),
            loteo_dfl: new FormControl(''),

            proyecto_etapas: new FormControl(''),
            proyecto_etapasModificacion: new FormControl(''),
            cantidad_etapas: new FormControl(''),
            cantidad_etapasModificacion: new FormControl(''),
            etapas_mitigaciones: new FormControl(''),
            etapas_mitigacionesModificacion: new FormControl(''),
            etapas_art9: new FormControl(''),
            etapas_art9Modificacion: new FormControl(''),

            etapas_ejecutadas: new FormControl(''),
            etapas_porEjecutar: new FormControl(''),
            tipo_reconstruccion: new FormControl(''),
            tipoAlteracion: new FormControl(''),
            tipoSupresion: new FormControl(''),
            tipoResRebReh: new FormControl(''),
            tipoResRebRehOtro: new FormControl(''),

            tipoAmpliacion: new FormControl(''),
            regularizacionToda: new FormControl(''),
            regularizacionUna: new FormControl(''),

            aumento_permiso: new FormControl(''),
            aumento_modificado: new FormControl(''),
            proyectoDe: new FormControl(''),


            /* form112 */
            descripcion_obras: new FormControl(''),
            tipo_obras1: new FormControl(''),
            emplazadaPiso_obras1: new FormControl(''),
            emplazadaSector_obras1: new FormControl(''),
            tipo_obras2: new FormControl(''),
            emplazadaPiso_obras2: new FormControl(''),
            emplazadaSector_obras2: new FormControl(''),
            tipo_obras3: new FormControl(''),
            emplazadaPiso_obras3: new FormControl(''),
            emplazadaSector_obras3: new FormControl(''),

        })

        if (!JSON.parse(localStorage.getItem("caract_anteproyecto_obranueva"))) {
            localStorage.setItem("caract_anteproyecto_obranueva", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("caract_anteproyecto_obranueva"));
            this.form.controls['anteProyectoAprobado'].setValue(this.rows[0] ? this.rows[0].anteProyectoAprobado : '');
            this.form.controls['anteProyectoAprobadoRes'].setValue(this.rows[0] ? this.rows[0].anteProyectoAprobadoRes : '');
            this.form.controls['anteProyectoAprobadoFecha'].setValue(this.rows[0] ? this.rows[0].anteProyectoAprobadoFecha : '');
            this.form.controls['tipo_permiso'].setValue(this.rows[0] ? this.rows[0].tipo_permiso : '');
            this.form.controls['num_permiso'].setValue(this.rows[0] ? this.rows[0].num_permiso : '');
            this.form.controls['fecha_permiso'].setValue(this.rows[0] ? this.rows[0].fecha_permiso : '');
            this.form.controls['tipo_recepcion'].setValue(this.rows[0] ? this.rows[0].tipo_recepcion : '');
            this.form.controls['num_recepcion'].setValue(this.rows[0] ? this.rows[0].num_recepcion : '');
            this.form.controls['fecha_recepcion'].setValue(this.rows[0] ? this.rows[0].fecha_recepcion : '');
            this.form.controls['edificio_usoPublico'].setValue(this.rows[0] ? this.rows[0].edificio_usoPublico : '');
            this.form.controls['carga_ocupacionTotal'].setValue(this.rows[0] ? this.rows[0].carga_ocupacionTotal : '');
            this.form.controls['carga_ocupacionTotalReconstruccion'].setValue(this.rows[0] ? this.rows[0].carga_ocupacionTotalReconstruccion : '');
            this.form.controls['densidadOcupacion'].setValue(this.rows[0] ? this.rows[0].densidadOcupacion : '');
            this.form.controls['densidadOcupacionReconstruccion'].setValue(this.rows[0] ? this.rows[0].densidadOcupacionReconstruccion : '');
            this.form.controls['crecimientoUrbano'].setValue(this.rows[0] ? this.rows[0].crecimientoUrbano : '');
            this.form.controls['explicitar'].setValue(this.rows[0] ? this.rows[0].explicitar : '');
            this.form.controls['loteo_construccion'].setValue(this.rows[0] ? this.rows[0].loteo_construccion : '');
            this.form.controls['loteo_dfl'].setValue(this.rows[0] ? this.rows[0].loteo_dfl : '');

            this.form.controls['proyecto_etapas'].setValue(this.rows[0] ? this.rows[0].proyecto_etapas : '');
            this.form.controls['proyecto_etapasModificacion'].setValue(this.rows[0] ? this.rows[0].proyecto_etapasModificacion : '');
            this.form.controls['cantidad_etapas'].setValue(this.rows[0] ? this.rows[0].cantidad_etapas : '');
            this.form.controls['cantidad_etapasModificacion'].setValue(this.rows[0] ? this.rows[0].cantidad_etapasModificacion : '');

            this.form.controls['etapas_mitigaciones'].setValue(this.rows[0] ? this.rows[0].etapas_mitigaciones : '');
            this.form.controls['etapas_art9'].setValue(this.rows[0] ? this.rows[0].etapas_art9 : '');
            this.form.controls['etapas_mitigacionesModificacion'].setValue(this.rows[0] ? this.rows[0].etapas_mitigacionesModificacion : '');
            this.form.controls['etapas_art9Modificacion'].setValue(this.rows[0] ? this.rows[0].etapas_art9Modificacion : '');

            this.form.controls['etapas_ejecutadas'].setValue(this.rows[0] ? this.rows[0].etapas_ejecutadas : '');
            this.form.controls['etapas_porEjecutar'].setValue(this.rows[0] ? this.rows[0].etapas_porEjecutar : '');
            this.form.controls['tipo_reconstruccion'].setValue(this.rows[0] ? this.rows[0].tipo_reconstruccion : '');
            this.form.controls['tipoAlteracion'].setValue(this.rows[0] ? this.rows[0].tipoAlteracion : '');
            this.form.controls['tipoSupresion'].setValue(this.rows[0] ? this.rows[0].tipoSupresion : '');
            this.form.controls['tipoResRebReh'].setValue(this.rows[0] ? this.rows[0].tipoResRebReh : '');
            this.form.controls['tipoResRebRehOtro'].setValue(this.rows[0] ? this.rows[0].tipoResRebRehOtro : '');

            this.form.controls['aumento_permiso'].setValue(this.rows[0] ? this.rows[0].aumento_permiso : '');
            this.form.controls['aumento_modificado'].setValue(this.rows[0] ? this.rows[0].aumento_modificado : '');
            this.form.controls['proyectoDe'].setValue(this.rows[0] ? this.rows[0].proyectoDe : '');

            this.form.controls['descripcion_obras'].setValue(this.rows[0] ? this.rows[0].descripcion_obras : '');
            this.form.controls['tipo_obras1'].setValue(this.rows[0] ? this.rows[0].tipo_obras1 : '');
            this.form.controls['emplazadaPiso_obras1'].setValue(this.rows[0] ? this.rows[0].emplazadaPiso_obras1 : '');
            this.form.controls['emplazadaSector_obras1'].setValue(this.rows[0] ? this.rows[0].emplazadaSector_obras1 : '');
            this.form.controls['tipo_obras2'].setValue(this.rows[0] ? this.rows[0].tipo_obras2 : '');
            this.form.controls['emplazadaPiso_obras2'].setValue(this.rows[0] ? this.rows[0].emplazadaPiso_obras2 : '');
            this.form.controls['emplazadaSector_obras2'].setValue(this.rows[0] ? this.rows[0].emplazadaSector_obras2 : '');
            this.form.controls['tipo_obras3'].setValue(this.rows[0] ? this.rows[0].tipo_obras3 : '');
            this.form.controls['emplazadaPiso_obras3'].setValue(this.rows[0] ? this.rows[0].emplazadaPiso_obras3 : '');
            this.form.controls['emplazadaSector_obras3'].setValue(this.rows[0] ? this.rows[0].emplazadaSector_obras3 : '');


            this.form.controls['regularizacionToda'].setValue(this.rows[0] ? this.rows[0].regularizacionToda : '');
            this.form.controls['regularizacionUna'].setValue(this.rows[0] ? this.rows[0].regularizacionUna : '');



        }
        this.caract_anteproyecto_obranueva = {
            anteProyectoAprobado: "",
            anteProyectoAprobadoRes: "",
            anteProyectoAprobadoFecha: "",
            tipo_permiso: "",
            num_permiso: "",
            fecha_permiso: "",
            tipo_recepcion: "",
            num_recepcion: "",
            fecha_recepcion: "",
            edificio_usoPublico: "",
            carga_ocupacionTotal: "",
            carga_ocupacionTotalReconstruccion: "",
            densidadOcupacion: "",
            densidadOcupacionReconstruccion: "",
            crecimientoUrbano: "",
            explicitar: "",
            loteo_construccion: "",
            loteo_dfl: "",

            proyecto_etapas: "",
            proyecto_etapasModificacion: "",
            cantidad_etapas: "",
            cantidad_etapasModificacion: "",

            etapas_mitigaciones: "",
            etapas_art9: "",
            etapas_mitigacionesModificacion: "",
            etapas_art9Modificacion: "",

            etapas_ejecutadas: "",
            etapas_porEjecutar: "",
            tipo_reconstruccion: "",
            tipoAlteracion: "",
            tipoSupresion: "",
            tipoResRebReh: "",
            tipoResRebRehOtro: "",

            aumento_permiso: "",
            aumento_modificado: "",
            proyectoDe: "",

            descripcion_obras: "",
            tipo_obras1: "",
            emplazadaPiso_obras1: "",
            emplazadaSector_obras1: "",
            tipo_obras2: "",
            emplazadaPiso_obras2: "",
            emplazadaSector_obras2: "",
            tipo_obras3: "",
            emplazadaPiso_obras3: "",
            emplazadaSector_obras3: "",

        };

    }

    add_caract_anteproy() {
        console.log("ACA", this.form.value.tipoAmpliacion);


        if (this.form.value.tipoAlteracion == "SUPRESIÓN O ADICIÓN") {
            this.alteracionSupresionAdicion = true
            this.alteracionResRemReh = false
            this.form.value.tipoResRebReh = ""
        } else if (this.form.value.tipoAlteracion == "RESTAURACIÓN" || this.form.value.tipoAlteracion == "REMODELACIÓN" || this.form.value.tipoAlteracion == "REHABILITACIÓN") {
            this.alteracionResRemReh = true
            this.alteracionSupresionAdicion = false
            this.form.value.tipoSupresion = ""
        }

        localStorage.setItem("caract_anteproyecto_obranueva", JSON.stringify([]));
        this.actualRow = localStorage.getItem("caract_anteproyecto_obranueva");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            anteProyectoAprobado: this.form.value.anteProyectoAprobado,
            anteProyectoAprobadoRes: this.form.value.anteProyectoAprobadoRes,
            anteProyectoAprobadoFecha: this.form.value.anteProyectoAprobadoFecha ? moment(this.form.value.anteProyectoAprobadoFecha).format('DD/MM/YYYY') : "",
            tipo_permiso: this.form.value.tipo_permiso,
            num_permiso: this.form.value.num_permiso,
            fecha_permiso: this.form.value.fecha_permiso,
            tipo_recepcion: this.form.value.tipo_recepcion,
            num_recepcion: this.form.value.num_recepcion,
            fecha_recepcion: this.form.value.fecha_recepcion,
            edificio_usoPublico: this.form.value.edificio_usoPublico,
            carga_ocupacionTotal: this.form.value.carga_ocupacionTotal,
            carga_ocupacionTotalReconstruccion: this.form.value.carga_ocupacionTotalReconstruccion,
            densidadOcupacion: this.form.value.densidadOcupacion,
            densidadOcupacionReconstruccion: this.form.value.densidadOcupacionReconstruccion,
            crecimientoUrbano: this.form.value.crecimientoUrbano,
            explicitar: this.form.value.explicitar,
            loteo_construccion: this.form.value.loteo_construccion,
            loteo_dfl: this.form.value.loteo_dfl,

            proyecto_etapas: this.form.value.proyecto_etapas,
            proyecto_etapasModificacion: this.form.value.proyecto_etapasModificacion,
            cantidad_etapas: this.form.value.cantidad_etapas,
            cantidad_etapasModificacion: this.form.value.cantidad_etapasModificacion,

            etapas_mitigaciones: this.form.value.etapas_mitigaciones,
            etapas_art9: this.form.value.etapas_art9,
            etapas_mitigacionesModificacion: this.form.value.etapas_mitigacionesModificacion,
            etapas_art9Modificacion: this.form.value.etapas_art9Modificacion,

            etapas_ejecutadas: this.form.value.etapas_ejecutadas,
            etapas_porEjecutar: this.form.value.etapas_porEjecutar,
            tipo_reconstruccion: this.form.value.tipo_reconstruccion,
            tipoAlteracion: this.form.value.tipoAlteracion,
            tipoAmpliacion: this.form.value.tipoAmpliacion,
            tipoSupresion: this.form.value.tipoSupresion,
            tipoResRebReh: this.form.value.tipoResRebReh,
            tipoResRebRehOtro: this.form.value.tipoResRebRehOtro,

            aumento_permiso: this.form.value.aumento_permiso,
            aumento_modificado: this.form.value.aumento_modificado,
            proyectoDe: this.form.value.proyectoDe,

            descripcion_obras: this.form.value.descripcion_obras,
            tipo_obras1: this.form.value.tipo_obras1,
            emplazadaPiso_obras1: this.form.value.emplazadaPiso_obras1,
            emplazadaSector_obras1: this.form.value.emplazadaSector_obras1,
            tipo_obras2: this.form.value.tipo_obras2,
            emplazadaPiso_obras2: this.form.value.emplazadaPiso_obras2,
            emplazadaSector_obras2: this.form.value.emplazadaSector_obras2,
            tipo_obras3: this.form.value.tipo_obras3,
            emplazadaPiso_obras3: this.form.value.emplazadaPiso_obras3,
            emplazadaSector_obras3: this.form.value.emplazadaSector_obras3,

            regularizacionToda: this.form.value.regularizacionToda,
            regularizacionUna: this.form.value.regularizacionUna,

        })
        localStorage.setItem("caract_anteproyecto_obranueva", JSON.stringify(this.rows));

    }

    delete_Caract_anteproyecto_obranueva(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caract_anteproyecto_obranueva", JSON.stringify(this.rows));
            }
        }
    }

    onNgModelChangeAlt(event) {
        console.log('on ng model change', event)


        this.tipo_alt = event
        this.add_caract_anteproy()
    }



}